import React, {useEffect} from 'react';
import {withTranslation} from "react-i18next";
import Layout from "../../layout/Layout";
import {format_date, getData} from "../../helpers/utils";


const Portfolio = ({t}) => {

    const [data, setData] = React.useState([]);

    useEffect(() => {
      loadData();
    }, []);

    const loadData = async () => {
        setData(await getData())
    }




    return (
        <Layout>
            <section className="bg-dark pt-lg-8">
                <div className=" container pt-4 pt-lg-0" data-bs-theme="dark">
                    <div className=" row align-items-center mb-7">
                        <div className="col-xl-6">
                            <h1 className="display-5">Highlights of cases that we've built</h1>
                        </div>
                        <div className="col-xl-5 ms-auto">
                            <p className="mb-4">The combination of my passion for design, code & interaction positions
                                me in a unique place in the web design world.</p>
                            <div className="text-center d-inline-block bg-light border rounded px-5 py-3">
                                <span className="heading-color">Work with us?</span> <a className="ms-2"
                                                                                        href="contact-v2.html">Contact
                                us now<span className="bi-chevron-right small ms-1"></span></a>
                            </div>
                        </div>
                    </div>


                </div>
            </section>

            <section>
                <div className="container">
                    {data?.portfolio?.map((item, index) => (
                        <div className="card card-img-scale bg-transparent overflow-hidden mb-6 mb-xl-8" key={item.id}>
                            <div className="row g-xl-6 align-items-center">
                                {/* Condition pour alterner la disposition */}
                                {index % 2 === 0 ? (
                                    <>
                                        <div className="col-lg-6">
                                            <div className="card-img-scale-wrapper rounded-2 h-100">
                                                <img src={item.picture} className="img-scale" alt="portfolio-img"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="card-body h-100 px-0 p-xl-5">
                                                <img src={item.logo} className="h-30px mb-3 mb-lg-4" alt="Client-img"/>
                                                <h4 className="card-title">{item.name}</h4>
                                                <p className="card-text mb-3 mb-lg-4">{item.description}</p>
                                                <div
                                                    className="d-flex gap-2 gap-sm-3 gap-lg-1 flex-lg-column flex-wrap mb-3 mb-lg-4">
                                                    <div>
                                                        <i className="fa-solid fa-circle fa-2xs text-primary me-2"></i>
                                                        <b>{new Date(item.started_at).getFullYear()}</b>
                                                    </div>
                                                    <span>{item?.category}</span>
                                                    <span>{format_date(item?.started_at)}</span>
                                                    <span>{format_date(item?.end_at)}</span>
                                                </div>
                                                <a href={item.link}
                                                   className="text-primary-hover stretched-link heading-color mb-0"
                                                   target="_blank">
                                                    {t('read_more')}
                                                    <i className="fa-solid fa-arrow-right-long fa-fw ms-2"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-lg-6 order-2 order-lg-1">
                                            <div className="card-body text-lg-end h-100 px-0 p-xl-5">
                                                <img src={item.logo} className="h-30px mb-3 mb-lg-4" alt="Client-img"/>
                                                <h4 className="card-title">{item.name}</h4>
                                                <p className="card-text mb-3 mb-lg-4">{item.description}</p>
                                                <div
                                                    className="d-flex justify-content-lg-end gap-2 gap-sm-3 gap-lg-1 flex-lg-column flex-wrap mb-3 mb-lg-4">
                                                    <div>
                                                        <i className="fa-solid fa-circle fa-2xs text-primary me-2"></i>
                                                        <b>{new Date(item.started_at).getFullYear()}</b>
                                                    </div>
                                                    <span>{item?.category}</span>
                                                    <span>{format_date(item?.started_at)}</span>
                                                    <span>{format_date(item?.end_at)}</span>

                                                </div>
                                                <a href={item.link} target="_blank"
                                                   className="text-primary-hover stretched-link heading-color mb-0">
                                                    {t('read_more')}
                                                    <i className="fa-solid fa-arrow-right-long fa-fw ms-2"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 order-1 order-lg-2">
                                            <div className="card-img-scale-wrapper rounded-2 h-100">
                                                <img src={item.picture} className="img-scale" alt="portfolio-img"/>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <div className="row mt-7 mb-7">
                <div className="col-12">
                    <ul className="pagination pagination-primary-soft list-unstyled d-flex justify-content-center flex-wrap mb-0">
                        <li className="page-item">
                            <a className="page-link" href="#"><i
                                className="fas fa-long-arrow-alt-left me-2 rtl-flip"></i>Prev</a>
                        </li>
                        <li className="page-item"><a className="page-link" href="#">1</a></li>
                        <li className="page-item active"><a className="page-link" href="#">2</a></li>
                        <li className="page-item"><a className="page-link" href="#">3</a></li>
                        <li className="page-item"><a className="page-link" href="#">..</a></li>
                        <li className="page-item"><a className="page-link" href="#">22</a></li>
                        <li className="page-item"><a className="page-link" href="#">23</a></li>
                        <li className="page-item">
                            <a className="page-link" href="#">Next<i
                                className="fas fa-long-arrow-alt-right ms-2 rtl-flip"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
        </Layout>
    )
}

export default withTranslation()(Portfolio)